export const CTA_TEXT_DEFAULT = "Learn More"
